"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _eventEmitter = _interopRequireDefault(require("../eventEmitter"));

var _transport = _interopRequireDefault(require("../../transport/transport.xhr"));

var _sync = require("./sync.constants");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var CONNECTING = 0,
    CLOSED = 3,
    // CLOSING = 2,
OPEN = 1,
    INITIAL = -1,
    defaultOptions = {
  pollInterval: 100
};

var _default =
/*#__PURE__*/
function (_EventEmitter) {
  (0, _inherits2["default"])(_default, _EventEmitter);

  /**
   * @param {object} options
   * options.url - API URL
   * onOpen
   * onClose
   * onError - response protocol validation failed
   * onMessage
   */
  function _default() {
    var _this;

    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    (0, _classCallCheck2["default"])(this, _default);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(_default).call(this));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_handleStreamOpen", function (stream) {
      if (_this.isConnecting()) {
        _this.readyState = OPEN;

        if (typeof _this.options.onOpen === 'function') {
          _this.options.onOpen();
        }

        _this._runQueue();
      }

      return Promise.resolve(stream);
    });
    _this.stream = null;
    _this.queue = [];
    _this.readyState = INITIAL;
    _this.options = _objectSpread({}, defaultOptions, {}, options);
    _this.storage = options.storage;
    _this.url = options.url;
    _this.parsers = options.parsers;

    if (typeof options.protocol !== 'undefined') {
      _this.protocol = options.protocol;
    }

    _this.Transport = options.transport || _transport["default"];
    return (0, _possibleConstructorReturn2["default"])(_this, (0, _assertThisInitialized2["default"])(_this));
  }

  (0, _createClass2["default"])(_default, [{
    key: "isOpen",
    value: function isOpen() {
      return this.stream && this.readyState === OPEN;
    }
  }, {
    key: "isConnecting",
    value: function isConnecting() {
      return this.readyState === CONNECTING;
    }
  }, {
    key: "isClosed",
    value: function isClosed() {
      return this.readyState === CLOSED;
    }
  }, {
    key: "isInitial",
    value: function isInitial() {
      return this.readyState === INITIAL;
    }
  }, {
    key: "connect",
    value: function connect() {
      if (this.isInitial() || this.isClosed()) {
        this.readyState = CONNECTING;

        this._poll().then(this._handleStreamOpen);
      }

      return this;
    }
  }, {
    key: "close",
    value: function close() {
      if (this.stream && typeof this.stream.close === 'function') {
        this.stream.close();
      }

      this._handleStreamClose();

      return this;
    }
    /**
     * @param {object} data
     * @param {object} options
     * @return {Promise}
     */

  }, {
    key: "send",
    value: function send() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (this.isOpen()) {
        var transport, queryOptions;
        queryOptions = _objectSpread({}, this.options, {
          method: 'post',
          dataType: 'json',
          contentType: 'application/json'
        }, options);
        transport = new this.Transport(this.url, queryOptions);

        if (queryOptions.contentType === 'application/json') {
          data = JSON.stringify(data); // alias for migration from jquery to axios

          queryOptions.headers = queryOptions.headers || {};
          queryOptions.headers['Content-Type'] = queryOptions.contentType;
        }

        if (queryOptions.dataType) {
          // alias for migration from jquery to axios
          queryOptions.responseType = queryOptions.dataType;
        }

        if (typeof transport.send === 'function') {
          return transport.send(data);
        } else {
          return Promise.reject(new Error('Pooling: send method is not defined. Check WebSocket transport API.'));
        }
      } else {
        return this._addToQueue(data);
      }
    }
  }, {
    key: "setURL",
    value: function setURL(url) {
      if (url) {
        this.url = url;
      }

      return this;
    }
  }, {
    key: "_handleStreamClose",
    value: function _handleStreamClose() {
      if (this.isOpen()) {
        this.readyState = CLOSED;

        this._stopQueue();

        this._clearQueue();

        if (typeof this.options.onClose === 'function') {
          this.options.onClose();
        }
      }
    }
  }, {
    key: "_nextPool",
    value: function _nextPool() {
      var _this2 = this;

      setTimeout(function () {
        if (_this2.isOpen()) {
          _this2._poll();
        }
      }, this.options.pollInterval);
      return this;
    }
  }, {
    key: "_poll",
    value: function _poll() {
      var _this3 = this;

      if (!this.url) {
        return Promise.reject(new Error('Pooling: missed required "url" attribute.'));
      } else {
        this.stream = new this.Transport(this.url, this.options);
        this.stream.get().then( // success
        this._handleStreamMessage.bind(this), // error, ignore errors
        function () {
          return Promise.resolve();
        }).then(function () {
          return _this3._nextPool();
        });
        return Promise.resolve(this.stream);
      }
    }
  }, {
    key: "_handleStreamMessage",
    value: function _handleStreamMessage(response) {
      var packet = {};

      if (typeof this.protocol === 'function') {
        // valid server response
        packet = this.protocol(response.data);
      } else {
        packet = {
          status: _sync.responseState.SUCCESS,
          data: response.data
        };
      } // response is invalid by protocol rules


      if (packet.status === _sync.responseState.ERROR) {
        if (typeof this.options.onError === 'function') {
          this.options.onError(packet);
        }
      } else if (packet.status === _sync.responseState.SUCCESS) {
        if (typeof this.options.onMessage === 'function') {
          this.options.onMessage(packet.data);
        }
      }

      return Promise.resolve(packet);
    }
  }, {
    key: "_clearQueue",
    value: function _clearQueue() {
      this.queue.length = 0;
    }
  }, {
    key: "_stopQueue",
    value: function _stopQueue() {
      return clearInterval(this._queueInterval);
    }
  }, {
    key: "_runQueue",
    value: function _runQueue() {
      var _this4 = this;

      this._stopQueue();

      this._queueInterval = setInterval(function () {
        if (_this4.isOpen() && _this4.queue.length) {
          var item = _this4.queue.unshift();

          if (typeof item.cb === 'function') {
            item.cb();
          }

          if (typeof item.p === 'function') {
            item.p();
          }
        }
      }, 100);
    }
  }, {
    key: "_addToQueue",
    value: function _addToQueue(data) {
      var _this5 = this;

      return new Promise(function (resolve) {
        _this5.queue.push({
          p: resolve,
          cb: function cb() {
            return _this5.send(data);
          }
        });
      });
    }
  }]);
  return _default;
}(_eventEmitter["default"]);

exports["default"] = _default;